module.exports = __webpack_public_path__ + "static/media/ps.1b8d0399.svg";